module.exports = __webpack_public_path__ + "static/how-t0-share__widget-bca550f0acea47c9587f2c73109c52e5.jpg";